import React from 'react';
import { validateString } from 'avilatek-utils';
import { Button, Input, TagsInput } from '@avila-tek/ui/src';
import { Option } from '../../../models';
import { useNotify } from '../../../hooks';

interface OptionFormDetailProps {
  setOptions?: React.Dispatch<React.SetStateAction<Option[]>>;
  options?: Option[];
  idx?: number;
  id?: string;
  remove?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function OptionFormDetail({
  setOptions,
  options,
  idx,
  id,
  remove,
}: OptionFormDetailProps) {
  const [name, setName] = React.useState<string>('');
  const [values, setValues] = React.useState<{ text: string; id: string }[]>(
    []
  );
  const notify = useNotify();
  React.useEffect(() => {
    const _options = options.slice();
    _options[idx].name = name;
    _options[idx].values = values.map((value) => value.text);
    setOptions(_options);
  }, [name, values]);

  const onChange = React.useCallback((e) => {
    e.preventDefault();
    const { value } = e.target;
    if ((validateString(value) && String(value).length <= 127) || !value) {
      setName(value);
    }
  }, []);

  return (
    <div className=" ">
      <div className=" w-full flex flex-wrap flex-row justify-between ">
        <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider  ">
          Título de la variante
        </span>
        {idx !== 0 && (
          <Button
            type="button"
            className="p-0 m-0 bg-transparent text-sm text-primary-400 w-fit ml-auto "
            data-id={id}
            onClick={remove}
          >
            Desactivar Variante
          </Button>
        )}
      </div>
      <div className=" w-full flex flex-wrap md:flex-row flex-col gap-4 md:gap-0">
        <div className="w-full lg:w-1/3 ">
          <Input
            label=""
            name={`option[${idx}]`}
            type="text"
            placeholder="Ingrese el título"
            value={name}
            onChange={onChange}
          />
        </div>
        <div className="w-full lg:w-2/3 lg:pl-4 flex flex-col">
          <TagsInput
            tags={values}
            updateTags={setValues}
            onError={(error) => notify(error, 'error')}
          />
          <span className="text-gray-300 text-sm font-medium ml-2">
            Valor de la variante. Ejemplo: si título es talla los valores pueden
            ser S, M, L
          </span>
        </div>
      </div>
    </div>
  );
}

export default OptionFormDetail;
